import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'antd'
import { Input } from '@/ui'
import CustomIcon from 'gyl-common/components/CustomIcon'

import styles from './index.less'

const { TextArea } = Input

export default ({ visible, onOk, onCancel, data, defaultValue = '', formatValue, zIndex = 1000 }) => {
    const { modelTitle, tips } = data
    const [input, setInput] = useState(undefined)

    useEffect(() => {
        if (visible) {
            setInput(defaultValue)
        }
    }, [visible])

    return (
        <Modal
            width="383px"
            style={{ top: '8%' }}
            visible={visible}
            bodyStyle={{
                padding: '16px 24px'
            }}
            maskClosable={false}
            title={modelTitle}
            destroyOnClose={true}
            footer={
                <div className={styles.footer}>
                    <div className={styles.clear} onClick={() => setInput(undefined)}>
                        <CustomIcon className={styles.icon} type="icon-icon-shanchu" />
                        清空
                    </div>
                    {/* <Button
                        icon={<CustomIcon type="icon-icon-shanchu" />}
                        type="text"
                        onClick={() => setInput(undefined)}>
                        清空
                    </Button> */}
                    <div>
                        <Button className={styles.btn} onClick={onCancel}>
                            取消
                        </Button>
                        <Button
                            className={styles.btn}
                            type="primary"
                            onClick={() => {
                                onOk(input)
                            }}
                        >
                            确定
                        </Button>
                    </div>
                </div>
            }
            onCancel={onCancel}
            zIndex={zIndex}
        >
            <div className={styles.container}>
                <div className={styles.tips}>{tips}</div>
                <div className="content">
                    <TextArea
                        spellcheck="false"
                        value={input}
                        rows={10}
                        placeholder={modelTitle}
                        onChange={e => {
                            const value = e.target.value
                            const newVal = formatValue ? formatValue(value) : value
                            setInput(newVal)
                        }}
                    />
                </div>
            </div>
        </Modal>
    )
}
